import { useCallback, useEffect, useState } from "react";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

let deferredPrompt = null;
const listeners = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn());
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn());
  });
}

// Instalação como aplicação (PWA): prompt nativo no Chrome/Edge/Android; instruções manuais no iOS/Safari
export const usePwaInstall = () => {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((n) => n + 1);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);

  const installed = isStandalone();
  const install = useCallback(async () => {
    if (!deferredPrompt) return "unavailable";
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") deferredPrompt = null;
    listeners.forEach((fn) => fn());
    return outcome;
  }, []);

  return { installed, canPrompt: !!deferredPrompt && !installed, ios: isIOS(), install };
};

export const registerServiceWorker = () => {
  if (!("serviceWorker" in navigator)) return;
  const mode = process.env.NODE_ENV === "production" ? "prod" : "dev";
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`/sw.js?mode=${mode}`).then((reg) => {
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        sw?.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent("lumora:sw-update", { detail: reg }));
          }
        });
      });
    }).catch(() => {});
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
};
